import React, { useEffect, useState } from 'react';
import { Form, Button, Modal } from 'react-bootstrap';
import styles from '../../css/Header.module.css';
import FindUserByOrgDialog, {
  FindUserByOrgFilledNote,
  FindUserByOrgLink,
} from '../findUserByOrg/FindUserByOrgDialog';
import finderStyles from '../findUserByOrg/FindUserByOrgDialog.module.css';

export const AssumeUserModal = ({
  isShowingModal,
  handleClose,
  handleSave,
  onChange,
  txtAssumeUser,
  type = 'text',
  showFindByOrganization = false,
}) => {
  const [finderOpen, setFinderOpen] = useState(false);
  const [filledFrom, setFilledFrom] = useState('');

  useEffect(() => {
    if (!isShowingModal) setFilledFrom('');
  }, [isShowingModal]);

  return (
  <>
  <Modal
    className={styles.assumeUserModal}
    show={isShowingModal && !finderOpen}
    onHide={handleClose}
  >
    <Modal.Header className={styles.modalHeader} closeButton></Modal.Header>
    <Modal.Body className={styles.modalBody}>
      {showFindByOrganization ? (
        <div className={finderStyles.labelRow}>
          <span>Enter Assumed User ID</span>
          <FindUserByOrgLink onClick={() => setFinderOpen(true)} />
        </div>
      ) : (
        'Enter Assumed User ID'
      )}
      <Form className={styles.form}>
        <Form.Row>
          <Form.Control
            type={type}
            className={styles.textInput}
            value={txtAssumeUser}
            // Refocused after the finder fills in an email.
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus={Boolean(filledFrom)}
            onChange={(e) => {
              setFilledFrom('');
              onChange(e);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSave();
              }
            }}
          />
        </Form.Row>
      </Form>
      <FindUserByOrgFilledNote organizationName={filledFrom} />
    </Modal.Body>
    <Modal.Footer className={styles.modalFooter}>
      <Button size="lg" block className={styles.button} onClick={handleSave}>
        SUBMIT
      </Button>
    </Modal.Footer>
  </Modal>
  {showFindByOrganization ? (
    <FindUserByOrgDialog
      show={finderOpen}
      onClose={() => setFinderOpen(false)}
      onSelect={(webId, organizationName) => {
        onChange({ target: { value: webId } });
        setFilledFrom(organizationName);
        setFinderOpen(false);
      }}
    />
  ) : null}
  </>
  );
};

export const RemoveAssumeUserModal = ({
  handleCloseUnassume,
  handleCloseUnassumeNo,
  isShowingModalUnassume,
  assumeUserVal,
}) => (
  <Modal
    className={styles.removeAssumeUserModal}
    show={isShowingModalUnassume}
    onHide={handleCloseUnassumeNo}
  >
    <Modal.Header className={styles.modalHeader} closeButton></Modal.Header>
    <Modal.Body className={styles.removeAssumeUserBody}>
      Do you want to release this User?
      <p className={styles.removeAssumeUserName}>{assumeUserVal}</p>
    </Modal.Body>
    <Modal.Footer className={styles.modalFooter}>
      <Button
        size="lg"
        block
        className={styles.button_no}
        onClick={handleCloseUnassumeNo}
      >
        NO
      </Button>
      <Button
        size="lg"
        block
        className={styles.button_yes}
        onClick={handleCloseUnassume}
      >
        YES
      </Button>
    </Modal.Footer>
  </Modal>
);
